<template lang="pug">
  div
    section.content-header
      h1 添付ファイルサイズ設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active 添付ファイルサイズ設定

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル
        +btnbar

        .box.box-widget
          .box-body

            .form-group
              label.control-label(for="") ファイルサイズの上限
              .form-inline
                select.form-control(v-model="attachsize")
                  option(v-for="(value, key, index) in attachsizeoptions" :value="value" :key="index") {{key}}
              .help-block
                p.bcard-comments.text-info
                  | ※ 1 ファイル あたりのアップロードできるファイルサイズの上限を設定します。

        +btnbar.-bottom

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AttachsizeSettingRepository = RepositoryFactory.get('attachsizesettings')

export default {
  name: 'Attachsizesetting',
  components: { AppMessages },
  data: function () {
    return {
      attachsize: '',
      attachsizeoptions: [],

      isLoading: true // 読み込み中かどうか
    }
  },
  created: function () {
    const vm = this

    // API実行
    AttachsizeSettingRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.attachsize = data.attachsize
        vm.attachsizeoptions = data.attachsizeoptions

        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    // ファイルサイズ設定の登録・更新
    postData () {
      const vm = this
      let params = {
        attachsize: vm.attachsize
      }

      // API実行
      AttachsizeSettingRepository.put(params)
        .then(function () {
        // 成功時は設定状況に遷移
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
        // エラー時はメッセージを表示
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/AttachsizeSetting.vue